import { Component, inject, output, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { generateReservationEvent } from '@helpers/google-analytics.helper';
import { AdvertViewModel } from '@models/advert/advert';
import { AnalyticsService } from '@services/analytics.service';
import { UserSettingsService } from '@services/user-settings.service';
import { takeUntil } from 'rxjs';
import { UnSubscriptionDirective } from '@directives/unsubscribe.directive';
import { IReservationModalArgs, ReservationComponent } from '../reservation/reservation.component';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { ClickAndKeydownDirective } from '@directives/click-and-keydown.directive';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'publish-bar',
    templateUrl: 'publish-bar.component.html',
    styleUrls: ['publish-bar.component.less'],
    imports: [MatButton, RouterLink, ClickAndKeydownDirective, MatIcon, MatMenuTrigger, MatMenu, MatMenuItem, TranslateModule]
})
export class PublishBarComponent extends UnSubscriptionDirective {
    private dialog = inject(MatDialog);
    private gaService = inject(AnalyticsService);
    private userSettingsService = inject(UserSettingsService);

    readonly advert = input<AdvertViewModel>(undefined);
    readonly isPreview = input<boolean>(false);
    readonly published = output();
    readonly unpublished = output();
    readonly reservationChanged = output();

    get isStandaloneDisplayMode(): boolean {
        return this.userSettingsService.isStandaloneDisplayMode();
    }

    publish(): void {
        this.published.emit();
    }

    unpublish(): void {
        this.unpublished.emit();
    }

    toggleReservation(): void {
        const advert = this.advert();
        generateReservationEvent(advert, this.gaService);

        const args: IReservationModalArgs = {
            advertId: advert.id,
            isReserved: advert.isReserved,
        };

        const dialog = this.dialog.open(ReservationComponent, { data: args });
        dialog
            .afterClosed()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => this.reservationChanged.emit());
    }
}
